import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import VideoMatrix from './components/VideoMatrix';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '吃瓜视频网',
        url: 'https://www.chiguavideo.com',
        description: '吃瓜视频网汇聚吃瓜视频在线播放与在线观看吃瓜视频核心入口，同步更新国产吃瓜视频及吃瓜视频网站热门爆料。',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'contact@chiguavideo.com',
        },
      },
      {
        '@type': 'WebSite',
        name: '吃瓜视频网',
        url: 'https://www.chiguavideo.com',
        description: '吃瓜视频在线播放 | 国产吃瓜视频与吃瓜视频网站 | 在线观看吃瓜视频每日猛料',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.chiguavideo.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '吃瓜视频网首页 - 每日猛料实时更新',
        url: 'https://www.chiguavideo.com/',
        description: '吃瓜视频网首页，汇聚全网最新最热吃瓜视频内容。',
        isPartOf: { '@id': '#website' },
      },
    ],
  };

  return (
    <>
      <SEO
        title="吃瓜视频网 - 吃瓜视频在线播放 | 国产吃瓜视频与吃瓜视频网站 | 在线观看吃瓜视频每日猛料"
        description="吃瓜视频网汇聚吃瓜视频在线播放与在线观看吃瓜视频核心入口，整合吃瓜视频在线观看完整版延禧攻略等长尾资源，同步更新国产吃瓜视频及吃瓜视频网站热门爆料，是追网红大瓜与明星塌房现场的首选承接页。"
        keywords="吃瓜视频网,吃瓜视频在线播放,在线观看吃瓜视频,吃瓜视频在线观看完整版延禧攻略,国产吃瓜视频,吃瓜视频网站,吃瓜视频在线,吃瓜视频在线看,吃瓜视频官网,吃瓜视频入口"
        canonicalUrl="https://www.chiguavideo.com/"
        ogTitle="吃瓜视频网 - 吃瓜视频在线播放 | 国产吃瓜视频与吃瓜视频网站"
        ogUrl="https://www.chiguavideo.com/"
        ogType="website"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <VideoMatrix />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}